import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const AssignedTotesCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Assigned totes",
    cell: (row) => {
      if (!row.assignedTotes || row.assignedTotes.length === 0) {
        return "";
      }
      return row.assignedTotes.map((tote) => tote.name).join(", ");
    },
  };
